/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import {type SnackbarKey, SnackbarProvider, useSnackbar} from 'notistack';
import React from 'react';

const CloseButton: React.FC<{id: SnackbarKey}> = ({id}) => {
  const {closeSnackbar} = useSnackbar();

  return (
    <IconButton aria-label={'close'} color={'inherit'} onClick={() => closeSnackbar(id)} size={'small'}>
      <CloseIcon fontSize={'small'} />
    </IconButton>
  );
};

export const ToastProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      hideIconVariant
      variant={'default'}
      action={(key) => <CloseButton id={key} />}
    >
      {children}
    </SnackbarProvider>
  );
};
